import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    info: {
      title: translate({ id: 'setup.traffic.edit.info.title' }),
      point1: 'setup.traffic.edit.info.point1',
      point2: 'setup.traffic.edit.info.point2',
      point3: 'setup.traffic.edit.info.point3',
      point4: 'setup.traffic.edit.info.point4',
    },
    labelName: `${translate({ id: 'setup.traffic.edit.labels.name' })} *`,
    drivingTime: translate({ id: 'setup.traffic.defaultDrivingTimeLabelText' }),
    drivingTimeHelper: translate({ id: 'setup.traffic.edit.defaultDrivingTimeTitle.helper' }),
    timeWindows: translate({ id: 'setup.traffic.timeWindowsDrivingTimeText' }),
    errorName: translate({ id: 'setup.traffic.edit.validation.name' }),
    errorPoints: translate({ id: 'setup.traffic.edit.validation.points' }),
  }))

  return api
}
